import ReactDOM from 'react-dom';

import { normalizeSrc } from '@/app/components/media/app-image/shared/image-source';
import {
  type ImageRuntimeEnv,
  shouldUseRootAssetResourceHintForEnv,
} from '@/app/components/media/app-image/shared/project-adapter';
import { IMAGE_PROJECT_CONFIG } from '@/app/components/media/app-image/shared/project-config';

export const PRODUCTION_ASSET_ORIGIN =
  IMAGE_PROJECT_CONFIG.resourceHints.productionAssetOrigin;

export const shouldUseRootAssetResourceHint = (
  runtimeEnv: ImageRuntimeEnv = IMAGE_PROJECT_CONFIG.resourceHints.getRuntimeEnv()
): boolean => shouldUseRootAssetResourceHintForEnv(runtimeEnv);

export const getPreconnectOriginFromImageSrc = (
  src: unknown
): string | null => {
  const value = normalizeSrc(src).trim();
  if (!value) return null;

  try {
    const url = new URL(value);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;

    return url.origin;
  } catch {
    return null;
  }
};

export const getImageResourceHintOrigin = (
  src: unknown,
  runtimeEnv: ImageRuntimeEnv = IMAGE_PROJECT_CONFIG.resourceHints.getRuntimeEnv()
): string | null => {
  const origin = getPreconnectOriginFromImageSrc(src);
  if (!origin) return null;

  if (
    shouldUseRootAssetResourceHint(runtimeEnv) &&
    origin === PRODUCTION_ASSET_ORIGIN
  ) {
    return null;
  }

  return origin;
};

export const preconnectResourceHintOrigin = (origin: string): void => {
  ReactDOM.preconnect(origin);
  ReactDOM.prefetchDNS(origin);
};

export const preconnectImageOrigin = (src: unknown): string | null => {
  const origin = getImageResourceHintOrigin(src);
  if (!origin) return null;

  preconnectResourceHintOrigin(origin);

  return origin;
};
